// extracted by mini-css-extract-plugin
module.exports = {"nav":"main-nav_nav__1oShT","pricing":"main-nav_pricing__YSx-H"};